import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calcul de la capacité du transformateur";
const DESCRIPTION =
  "Calcul de la capacité du transformateur. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "transformer capacity calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/transformer-capacity-calculator/";
function TransformerCapacityCalculator() {
  const [voltage, setVoltage] = useState("");
  const [current, setCurrent] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [steps, setSteps] = useState([]);
  const handleCalculate = () => {
    try {
      if (!voltage || !current) {
        setError("Veuillez entrer la tension et l'intensité du courant.");
        return;
      }
      const sqrt3 = Math.sqrt(3);
      const capacity = sqrt3 * parseFloat(voltage) * parseFloat(current);
      const calculationSteps = [
        `Racine carrée de 3 = ${sqrt3.toFixed(2)}`,
        `Tension électrique = ${voltage} Volt`,
        `Intensité du courant = ${current} Ampère`,
        `Capacité du transformateur = ${sqrt3.toFixed(
          2
        )} × ${voltage} × ${current} = ${capacity.toFixed(2)} Watt`,
      ];
      setResult(capacity.toFixed(2));
      setSteps(calculationSteps);
      setError("");
    } catch (err) {
      setError("Une erreur s'est produite lors du calcul. Veuillez réessayer.");
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule la capacité d'un transformateur électrique pour n'importe quelle installation à l'aide de l'équation suivante :
                </p>
                <p>
                  <strong>
                    Capacité du transformateur = Racine carrée de 3 × Tension × Intensité du courant
                  </strong>
                </p>
                <ul>
                  <li>
                    Entrez la tension électrique et l'intensité du courant requise pour calculer la capacité du transformateur.
                  </li>
                  <li>
                    Assurez-vous d'étudier tous les charges et les courants de démarrage avant le calcul.
                  </li>
                </ul>
                <p>
                  Cette calculatrice a été développée pour faciliter le calcul de la capacité du transformateur électrique et assurer que les besoins de l'installation sont satisfaits efficacement.
                </p>
                <hr />
              </div>
              <br />
            </div>
               <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="ltr">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="voltage">
                      <label className="form-label ms-2">
                        Entrez la tension électrique (Volt)
                      </label>
                      <input
                        id="voltage"
                        type="number"
                        value={voltage}
                        onChange={(e) => setVoltage(e.target.value)}
                        placeholder="Entrez la tension électrique"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="current">
                      <label className="form-label ms-2">
                        Entrez l'intensité du courant (Ampère)
                      </label>
                      <input
                        id="current"
                        type="number"
                        value={current}
                        onChange={(e) => setCurrent(e.target.value)}
                        placeholder="Entrez l'intensité du courant"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur : {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">Résultat :</h4>
                      <p className="text-white">{result} Watt</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4>Étapes :</h4>
                        <ul>
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default TransformerCapacityCalculator;
